let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCDH8")).then(() => parcelRequire('eIbVY'));